module.exports = __webpack_public_path__ + "static/media/201CS142.7739c13f.jpg";